import ApiRequestManagerInstance from '../ApiRequestManager';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import User from '../../classes/user';
import { IMediaProductionRequest } from '../../types/interfaces/rail';
import { RailDisplayMode } from '../../types/enums/rail';
import { store } from '../../store/store';

function mediaProductionRequest(
  id: string,
  seasonNumber?: number,
  isRecord?: boolean
) {
  const promise = new Promise<Rail[]>(async (resolve) => {
    try {
      const { channels, user } = store.getState();
      const plan = User.getPlan(user.planId || null);
      const response: IMediaProductionRequest =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: 'apiUrl',
            version: 'v4',
            section: user.isAnonymous ? 'mediafree' : 'media',
            subsection: 'serie',
            type: isRecord ? 'record' : 'serie',
            params:
              TranslationManager.currentLanguage +
              (user.isAnonymous ? '&' + 'planCode=' + plan?.code : ''),
            replacement: id,
          },
        })) as unknown as IMediaProductionRequest;
      const episodes = response.data.chapters
        .filter((item) =>
          channels.favouriteChannels?.find(
            (channel) => channel.id === item.channel
          )
        )
        .map((item) => {
          return { ...item, season: seasonNumber };
        });
      const rail = {
        section: {
          title: `${response.data.media.title} ${
            response.data.media.season
              ? TranslationManager.get('MISC.EVENTS.SEASON') +
                ' ' +
                response.data.media.season
              : ''
          }`,
          presentationType: RailDisplayMode.PHOTO,
          name: response.data.media.id,
        },
        shows: { data: episodes },
      };
      const returnRail = new Rail(rail);
      if (returnRail.data.length) {
        resolve([returnRail]);
      }
      resolve([]);
    } catch (e) {
      console.error(e);
      resolve([]);
    }
  });

  return promise;
}

export default mediaProductionRequest;
